var LocalIP = process.env.REACT_APP_API_URL || 'https://edtuatbackend.onehublink.com/api';

export default LocalIP;
